import React, { useCallback, useRef } from 'react';
import {
  //DndProvider,
  useDrag,
  useDrop,
} from 'react-dnd';
import Table from '@/src/components/Antd/Table/SizeFittingTable';
//import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import { MenuOutlined } from '@ant-design/icons';
import css from './css.less';
import { get } from 'lodash';

//const type = 'DraggableRow';

const DraggableRow = ({
  index,
  moveRow,
  className,
  style = {},
  dataSource,
  rowKey,
  hideAllDragHandlers,
  type = 'DraggableRow',
  ...restProps
}) => {
  const ref = useRef();
  const [{ isOver, dropClassName }, drop] = useDrop({
    accept: type,
    collect: (monitor) => {
      const { index: dragIndex } = monitor.getItem() || ({} as any);
      if (dragIndex === index) {
        return {};
      }
      return {
        // isOver: monitor.isOver(),
        // dropClassName:
        //   dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
        isOver: monitor.isOver(),
        dropClassName:
          dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
      };
    },
    drop: (item: any) => {
      moveRow(item.index, index);
    },
  });
  const [, drag, preview] = useDrag({
    type,
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  const _style: any = {};

  const currentItem =
    dataSource.find((d) => {
      return (
        get(d, rowKey) === // d[rowKey]
        restProps['data-row-key']
      );
    }) || {};
  const { hideDragHandler } = currentItem;

  const _className = currentItem.dragable === false ? css.unDragable : '';
  if (currentItem.dragable !== false && !hideDragHandler) {
    drop(drag(ref));
    //_style.cursor = 'move';
  }

  const { children, ...rest } = restProps;
  //console.log('children', Array.isArray(children));
  //  console.log('children', children);
  const a = React.useMemo(() => {
    if (Array.isArray(children) && !hideAllDragHandlers) {
      return React.Children.map(children, (i, index) => {
        if (index === 0) {
          const ele = React.cloneElement(i, { ref: ref });
          return ele;
        }
        return i;
      });
    }
    return null;
  }, [children, hideAllDragHandlers]);

  // children[0].render = () => <div>123</div>;

  return (
    <tr
      ref={preview}
      className={`${className} ${_className} ${isOver ? dropClassName : ''}`}
      style={{
        ...style,
        ..._style,
      }}
      {...rest}>
      {a || children}
    </tr>
  );
};
//onTableChange为必传，每次排序后触发
//dragable -> 拖拽按钮是否置灰，
//hideDragHandler -> 单个拖拽按钮是否隐藏 无法拖拽
//hideAllDragHandlers -> 所有拖拽按钮是否隐藏 无法拖拽
const DroppableTable = (props) => {
  const {
    columns,
    dataSource,
    onTableChange,
    rowKey,
    hideAllDragHandlers,
    error,
    // dragHandle,
    type,
    ...rest
  } = props;

  const _columns = columns;

  const expandable = !hideAllDragHandlers
    ? {
        expandedRowRender: () => <p></p>,
        expandIcon: (data) => {
          //前置icons
          const { record } = data;
          const { hideDragHandler } = record || {};
          return !hideDragHandler ? (
            <MenuOutlined className={css.dragHandle} role={'dragHandler'} />
          ) : null;
        },
      }
    : {};

  const components = {
    body: {
      row: (p) =>
        DraggableRow({ ...p, dataSource, rowKey, hideAllDragHandlers, type }),
    },
  };

  const moveRow = useCallback(
    (dragIndex, hoverIndex) => {
      const dragRow = dataSource[dragIndex];
      onTableChange(
        update(dataSource, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragRow],
          ],
        }),
      );
    },
    [dataSource],
  );

  return (
    <React.Fragment>
      {error && <div className={css.errContainer}>{error}</div>}
      <Table
        rowKey={rowKey}
        columns={_columns}
        className={css.droppableTable}
        dataSource={dataSource}
        components={components}
        onRow={(record, index) => ({
          index,
          moveRow,
        })}
        expandable={expandable}
        {...rest}
      />
    </React.Fragment>
  );
};

export default DroppableTable;
